import { useAuth0 } from '@auth0/auth0-react';
import { RootState } from '@store/reducers';
import React, { ComponentType, ReactElement, useEffect } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { Button, Text, useIsInIframe } from 'shared-components';
import { useApplyWizardContext } from '../context/ApplyWizardContext';
import { ApplyWizardSteps, STEP_INTEGRATED_LOGIN } from '@components/ApplyWizard/ApplyWizardSteps';
import { useHistory } from 'react-router-dom';
import { reset } from 'redux-form';

export const ensureNotLoggedIn = <P extends object>(WrappedComponent?: ComponentType<P>) => {
  const mapStateToProps = (state: RootState) => {
    return {
      user: state.user,
    };
  };

  const connector = connect(mapStateToProps);
  type PropsFromRedux = ConnectedProps<typeof connector>;
  interface EnsureLoggedInProps extends PropsFromRedux {
    WrappedComponent: ComponentType<any>;
  }

  const EnsureNotLoggedIn: React.FC<EnsureLoggedInProps> = (props) => {
    const { user, ...rest } = props;
    const auth0 = useAuth0();
    const isOpenedInIframe = useIsInIframe();
    const { changeStepTo } = useApplyWizardContext();
    const history = useHistory();
    const dispatch = useDispatch();

    return user.loggedIn ? (
      <div className="p-6 flex flex-col items-center justify-center text-center gap-4">
        <Text variant="subheadline-sm2" className="!text-[16px] !font-extended py-[20px] !leading-[100%]">
          Equipment Financing Application
        </Text>
        <Text variant="subheadline-sm2" className="!text-[20px] !font-standard !leading-[30px]">
          This flow is meant for new customers
        </Text>

        <Text variant="subheadline-sm2" className="!text-[16px] !font-standard !leading-[110%]">
          You are logged in as {user.email}. Please sign out to start a new application or proceed to application flow
          designed for returning customers.
        </Text>
        <Button
          variant="primary-green"
          color="primary"
          type="submit"
          data-testid="info_continue"
          className="!max-w-[592px] !h-[50px] border-[1px] border-spark2 !py-[12.5px] font-condensed leading-[120%] px-[50px] !text-[16px]"
          onClick={() => {
            history.push('/');
          }}
        >
          START NEW APPLICATION
        </Button>
        <Button
          variant="text"
          className="!text-[12px]"
          onClick={(event: any) => {
            event.preventDefault();
            dispatch(reset('application'));
            auth0.logout({ logoutParams: { returnTo: window.location.origin } });
          }}
        >
          SIGN OUT
        </Button>
      </div>
    ) : WrappedComponent ? (
      <WrappedComponent {...(rest as P)} />
    ) : null;
  };

  return connector(EnsureNotLoggedIn);
};

export default ensureNotLoggedIn;
